export class DialogResult<T> {
  public static readonly CANCELLED = new DialogResult<undefined>(true);

  constructor(public readonly cancelled: boolean, public readonly data?: T) {}
}
